import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FiGithub, FiLinkedin, FiMail } from 'react-icons/fi';

const FooterWrapper = styled.footer`
  padding: 3rem 0;
  text-align: center;
  background: ${props => props.theme.colors.bg};
  border-top: 1px solid ${props => props.theme.colors.border};
  position: relative;
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2rem;
`;

const SocialLink = styled(motion.a)`
  color: ${props => props.theme.colors.textDim};
  font-size: 1.5rem;
  transition: all 0.3s;
  padding: 0.5rem;
  border-radius: 8px;
  
  &:hover {
    color: ${props => props.theme.colors.primary};
    background: rgba(56, 189, 248, 0.1);
    transform: translateY(-3px);
  }
`;

const Copy = styled.p`
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.85rem;
  color: ${props => props.theme.colors.textDark};
  margin-bottom: 0.5rem;
  
  span {
    color: ${props => props.theme.colors.primary};
  }
`;

const BuildInfo = styled.p`
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.75rem;
  color: ${props => props.theme.colors.textDark};
  opacity: 0.6;
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <SocialLinks>
        <SocialLink 
          href="https://github.com/CatYulHa" 
          target="_blank"
          whileHover={{ y: -3 }}
          whileTap={{ scale: 0.95 }}
        >
          <FiGithub />
        </SocialLink>
        <SocialLink 
          href="https://linkedin.com/in/yul-ha-a6199929a" 
          target="_blank"
          whileHover={{ y: -3 }}
          whileTap={{ scale: 0.95 }}
        >
          <FiLinkedin />
        </SocialLink>
        <SocialLink 
          href="https://mail.google.com/mail/?view=cm&fs=1&to=checkdata.yul@gmail.com"
          target="_blank"
          whileHover={{ y: -3 }}
          whileTap={{ scale: 0.95 }}
        >
          <FiMail />
        </SocialLink>
      </SocialLinks>
      <Copy>
        portfolio website by <span>Ha Yul</span>
      </Copy>
      <BuildInfo>
        쿠팡이츠서비스의 모든 개발은 1인 개발 하였습니다.
      </BuildInfo>
    </FooterWrapper>
  );
};

export default Footer;
